import React, { useState } from 'react';
import { MapPin, Coffee, Home, Eye, Droplet, Car, Utensils, Phone, Wrench } from 'lucide-react';
import '../styles/POIsPanel.css';

const POIsPanel = ({ pois }) => {
  const [filter, setFilter] = useState('all');

  if (!pois || pois.length === 0) {
    return (
      <div className="pois-panel-container">
        <div className="no-pois">
          <MapPin size={48} />
          <p>No s'han trobat POIs a prop de la ruta</p>
        </div>
      </div>
    );
  }

  const getIconForType = (type) => {
    const icons = {
      drinking_water: <Droplet size={18} />,
      shelter: <Home size={18} />,
      viewpoint: <Eye size={18} />,
      restaurant: <Utensils size={18} />,
      cafe: <Coffee size={18} />,
      parking: <Car size={18} />,
      toilets: <Home size={18} />,
      spring: <Droplet size={18} />,
      bicycle: <Wrench size={18} />,
      phone: <Phone size={18} />,
    };
    return icons[type] || <MapPin size={18} />;
  };

  const getColorForType = (type) => {
    const colors = {
      drinking_water: '#1e90ff',
      shelter: '#ff6347',
      viewpoint: '#32cd32',
      restaurant: '#ffa500',
      cafe: '#d2691e',
      parking: '#808080',
      toilets: '#9370db',
      spring: '#00bfff',
      bicycle: '#ff1493',
    };
    return colors[type] || '#667eea';
  };

  const translateType = (type) => {
    const translations = {
      drinking_water: 'Font',
      shelter: 'Refugi',
      viewpoint: 'Mirador',
      restaurant: 'Restaurant',
      cafe: 'Cafeteria',
      parking: 'Aparcament',
      toilets: 'Lavabos',
      spring: 'Font natural',
      bicycle: 'Botiga bicicletes',
      phone: 'Telèfon emergència',
    };
    return translations[type] || type;
  };

  const uniqueTypes = [...new Set(pois.map((poi) => poi.type))];
  const filteredPois = filter === 'all' ? pois : pois.filter((poi) => poi.type === filter);

  return (
    <div className="pois-panel-container fade-in">
      <div className="pois-header">
        <h3>
          <MapPin size={24} />
          Punts d'Interès ({pois.length})
        </h3>
        <p className="pois-subtitle">Des d'OpenStreetMap</p>
      </div>

      {uniqueTypes.length > 1 && (
        <div className="pois-filters">
          <button className={`filter-button ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>
            Tots ({pois.length})
          </button>
          {uniqueTypes.map((type) => (
            <button
              key={type}
              className={`filter-button ${filter === type ? 'active' : ''}`}
              onClick={() => setFilter(type)}
              style={{ borderColor: filter === type ? getColorForType(type) : 'transparent' }}
            >
              {translateType(type)} ({pois.filter((p) => p.type === type).length})
            </button>
          ))}
        </div>
      )}

      <div className="pois-list">
        {filteredPois.map((poi, index) => (
          <div key={index} className="poi-item">
            <div className="poi-icon" style={{ backgroundColor: getColorForType(poi.type) }}>
              {getIconForType(poi.type)}
            </div>
            <div className="poi-content">
              <div className="poi-header-row">
                <h4>{poi.name}</h4>
                {poi.distance_from_start !== undefined && (
                  <span className="poi-distance">KM {poi.distance_from_start.toFixed(1)}</span>
                )}
              </div>
              <span className="poi-type">{translateType(poi.type)}</span>
              <div className="poi-coordinates">
                📍 {poi.lat.toFixed(5)}, {poi.lon.toFixed(5)}
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredPois.length === 0 && (
        <div className="no-results">
          <p>No s'han trobat POIs d'aquest tipus</p>
        </div>
      )}
    </div>
  );
};

export default POIsPanel;